//import Libraries
import React from 'react';
import PropTypes from 'prop-types';

//import Components
import {FormGroup, Col, Label, Input} from 'reactstrap';

//import Styles


const productNumberFormGroup = (props) => {
    return (
        <FormGroup row>
            <Label sm={4} size="sm">{props.label}</Label>
            <Col sm={8}>
                <Input
                    type="number"
                    name={props.name}
                    onChange={props.onChange}
                    value={props.value}
                    disabled={props.disabled}
                    bsSize="sm"
                    min="0"
                />
            </Col>
        </FormGroup>
    );
}
export default productNumberFormGroup;

productNumberFormGroup.defaultProps = {
    disabled : false
}

productNumberFormGroup.propTypes = {
    disabled : PropTypes.bool
}


// WEBPACK FOOTER //
// ./src/pages/Admin/ProductManager/Category/Product/Elements/ProductNumberFormGroup.js